module.exports = __webpack_public_path__ + "media/customizations/mylwr/logo-3047526ce25c30f2e64541af50ec72d7.png";